import script from "./CopyString.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyString.vue?vue&type=script&setup=true&lang=ts"

import "./CopyString.vue?vue&type=style&index=0&id=55f0439c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f0439c"]])

export default __exports__